module.exports = __webpack_public_path__ + "img/phone.7a2b74e4.svg";